import withType from 'components/common/hoc/withType'
import { LazyDiv } from 'components/common/LazyHtml'

export default withType({ type: 'TeaserHtmlContentBlock' })(LazyDiv)
